import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62d17192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dimmer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_formatter = _resolveComponent("text-formatter")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, { class: "outer-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_text_formatter, {
          content: _ctx.translate('overview.beforeFirstVisitContent')
        }, null, 8, ["content"]),
        _hoisted_2
      ]),
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.readMore && _ctx.readMore(...args)))
      }, _toDisplayString(_ctx.translate('shared.readMore')), 1)
    ]),
    _: 1
  }))
}